







import { Component, Emit, Mixins, Prop, Watch, } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { Patient } from "../../../../domain/patient";
import { DisableableMixin } from "../../../system";
import { DuplicatedPatientSelectorDialog } from "../../dialogs/wizard/guest";

@Component({
  components: {
    DuplicatedPatientSelectorDialog,
  },
})
export default class DuplicatedPatientIndicator extends Mixins(DisableableMixin) {
  data() {
    return {
      isLoading: false,
      hasDuplicatedId: false,
    };
  }
  isLoading: boolean;
  hasDuplicatedId: boolean;

  $refs!: {
    selectorDialog: DuplicatedPatientSelectorDialog,
  };

  get isVisible(): boolean {
    return this.$configuration.behavior.patient.otherId.isEnable;
  }

  @Prop()
  patient: Patient;

  @Prop({ default: "他IDあり" })
  label: string;

  openSelectDialog(): void {
    this.$refs.selectorDialog.selectOption(this.patient)
    .then(p => {
      if (!!p) {
        this.patientSelected(p);
      }
    });
  }

  async checkDuplicatedId(): Promise<void> {
    try {
      const repository = DomainRegistry.patient.getPatientRepository();
      this.hasDuplicatedId = await repository.hasDuplicatedPatientId(this.patient.id);
    } catch (e) {
      this.$error("重複ID取得エラー", "患者重複ID取得に失敗しました。", e);
      this.hasDuplicatedId = false;
    }
  }

  @Watch("patient")
  async onPatientUpdated(newValue: Patient, oldValue: Patient): Promise<void> {
    if (this.isVisible && newValue && newValue !== oldValue) {
      this.isLoading = true;
      await this.checkDuplicatedId();
      this.isLoading = false;
    }
  }

  @Emit()
  patientSelected(patient: Patient): void {}
}
